import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createMessageCase,
  getMessageInfo,
} from "../../../app/redux/slices/app/messageSlice";
import { capitalize } from "../../../app/utils/utils.js";
import { CircularProgress } from "@mui/material";

const MessageDetails = ({ case_id, contactId }) => {
  const dispatch = useDispatch();

  const messageInfo = useSelector((state) => state.messageSlice.messageInfo);
  const createMessageCommentData = useSelector(
    (state) => state.messageSlice.createMessageCommentData
  );

  const { userAccountDetails } = useSelector((state) => state?.userDetailSlice);



  const [value, setValue] = useState({
    case_id: "",
    comment: "",
    commentedBy: "",
  });

  const btnSubmit = () => {
    const reqData = {
      ...value,
      email_id: messageInfo.data[0]?.email, //"kandasamy.maruthapillai@bytestreamsolutions.com",
      user_name: messageInfo.data[0]?.name,
      user_type: userAccountDetails?.userLoginInfo?.userTypeCode,
    };
    dispatch(createMessageCase({ ...reqData })).then(() => {
      dispatch(
        getMessageInfo({
          crm_contact_id: contactId,
          case_id: case_id,
        })
      );
    });
  };

  useEffect(() => {
    dispatch(
      getMessageInfo({
        crm_contact_id: contactId,
        case_id: case_id,
      })
    );
  }, [case_id]);

  return (
    <>
      <div className="row min-h-100 justify-content-center">
        <div className="col-xxl-12">
          <div className="card card-custom card-xxl-stretch message-box-card">
            <div className="card-body">
              <div className="card-body-content">
                <div className="d-flex flex-column gap-10px">
                  {messageInfo.loader ? (
                    <></>
                  ) : (
                    messageInfo?.data?.map((item, index) => (
                      <div key={index} className="message">
                        <div className="subject">{capitalize(item.title)}</div>
                        <div className="text">{item.description}</div>
                        <div className="time">
                          {new Date(item.created_date).toLocaleDateString()}
                        </div>

                        <div className="card card-custom comments">
                          <div className="card-header min-h-1px cp">
                            <p className={""}>
                              <i className="fa-sharp fa-solid fa-comment me-1"></i>
                              {item.messageComments?.length} Comments
                            </p>
                          </div>
                          <div>
                            {item.messageComments &&
                              Object.values(item.messageComments)
                                .sort(
                                  (a, b) =>
                                    new Date(b.created_date) -
                                    new Date(a.created_date)
                                )
                                .map((item, index) => (
                                  <div key={index} className="message readed">
                                    <div className="d-flex justify-content-between align-items-start">
                                      <div className="subject">
                                        {item.comments}
                                      </div>
                                      <div className="time">
                                        {new Date(
                                          item.created_date
                                        ).toLocaleDateString() +
                                          ", " +
                                          new Date(
                                            item.created_date
                                          ).toLocaleTimeString()}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                          </div>

                          <div className="comment p-3">
                            <div className="form-group">
                              <textarea
                                className="form-control"
                                id="exampleFormControlTextarea1"
                                rows="3"
                                placeholder="Add New Comment Here..."
                                onChange={(e) => {
                                  e.preventDefault();
                                  setValue({
                                    comment: e.target.value,
                                    case_id: item.case_id,
                                  });
                                }}
                              ></textarea>
                            </div>
                            <div className="text-end">
                              <button
                                className="btn btn-custom electric_cobalt"
                                onClick={(e) => {
                                  e.preventDefault();
                                  btnSubmit(item.contact_id);
                                }}
                              >
                                {createMessageCommentData?.loader ? (
                                  <CircularProgress size={22} />
                                ) : (
                                  "Submit"
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessageDetails;
